// src/pages/AuthRedirect.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Center, Spinner, Text, VStack, Button } from '@chakra-ui/react';
import { supabase } from '../config/supabaseClient';

const AuthRedirect = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [message, setMessage] = useState('Validando sua autenticação...');
    const [error, setError] = useState(false);

    // src/pages/AuthRedirect.jsx - Melhoria na verificação de perfil completo

    // No componente AuthRedirect.jsx, modifique a verificação de perfil:

    useEffect(() => {
        const handleAuthRedirect = async () => {
            try {
                //console.log("Auth Redirect: Iniciando verificação");

                // Verifica se há parâmetros de autenticação na URL (vindo de confirmação de email)
                const hash = window.location.hash;
                if (hash && hash.includes('access_token') && hash.includes('refresh_token')) {
                    //console.log("AuthRedirect: Parâmetros de autenticação encontrados na URL");

                    // Tenta configurar a sessão a partir dos parâmetros da URL
                    const setSessionFromUrl = async () => {
                        try {
                            // Extrai o access_token do hash
                            const accessTokenMatch = hash.match(/access_token=([^&]*)/);
                            const accessToken = accessTokenMatch ? accessTokenMatch[1] : null;

                            // Extrai o refresh_token do hash
                            const refreshTokenMatch = hash.match(/refresh_token=([^&]*)/);
                            const refreshToken = refreshTokenMatch ? refreshTokenMatch[1] : null;

                            if (accessToken && refreshToken) {
                                ///console.log("AuthRedirect: Tokens extraídos com sucesso, configurando sessão");

                                // Configura a sessão manualmente
                                const { data, error } = await supabase.auth.setSession({
                                    access_token: accessToken,
                                    refresh_token: refreshToken
                                });

                                if (error) throw error;

                                //console.log("AuthRedirect: Sessão configurada com sucesso a partir da URL");

                                // Verifica se o perfil está completo
                                if (data.session?.user) {
                                    const { data: profileData, error: profileError } = await supabase
                                        .from('profiles')
                                        .select('cpf_cnpj, phone')
                                        .eq('id', data.session.user.id)
                                        .single();

                                    // MODIFICAÇÃO AQUI: Verificação mais rigorosa do perfil completo
                                    // Verifica se o perfil existe E se tem CPF/CNPJ E telefone
                                    if (profileError || !profileData || !profileData.cpf_cnpj || !profileData.phone) {
                                        // Se o perfil não estiver completo, redireciona para completar o perfil
                                        setMessage('Redirecionando para completar seu perfil...');
                                        setTimeout(() => navigate('/complete-profile'), 1000);
                                    } else {
                                        // Se o perfil estiver completo, redireciona para o dashboard
                                        setMessage('Login bem-sucedido! Redirecionando para o Dashboard...');
                                        setTimeout(() => navigate('/dashboard'), 1000);
                                    }
                                } else {
                                    // Se não houver usuário na sessão, redireciona para o login
                                    setMessage('Erro ao processar autenticação. Redirecionando para login...');
                                    setTimeout(() => navigate('/login'), 2000);
                                }
                            } else {
                                throw new Error("Tokens de autenticação não encontrados na URL");
                            }
                        } catch (error) {
                            console.error("AuthRedirect: Erro ao configurar sessão a partir da URL:", error);
                            setError(true);
                            setMessage('Erro ao processar a autenticação. Tentando redirecionar...');
                            setTimeout(() => navigate('/login'), 3000);
                        }
                    };

                    await setSessionFromUrl();
                    return;
                }

                // Verifica a sessão atual
                const { data, error } = await supabase.auth.getSession();

                //console.log("Auth Redirect: Dados da sessão:", data);

                if (error) {
                    console.error("Auth Redirect: Erro na sessão:", error);
                    throw error;
                }

                // Se não há sessão, redireciona para login
                if (!data || !data.session) {
                    //console.log("Auth Redirect: Nenhuma sessão encontrada");
                    setMessage('Nenhuma sessão encontrada. Redirecionando para a página de login...');
                    setTimeout(() => navigate('/login'), 2000);
                    return;
                }

                // Verifica se é um novo usuário
                const { data: userMetadata } = await supabase.auth.getUser();
                //console.log("Auth Redirect: Dados do usuário:", userMetadata);

                // Verifica se o perfil existe para usuários OAuth
                if (userMetadata?.user) {
                    try {
                        const { data: profileData, error: profileError } = await supabase
                            .from('profiles')
                            .select('*')
                            .eq('id', userMetadata.user.id)
                            .single();

                        //console.log("Auth Redirect: Dados do perfil:", profileData);
                        //console.log("Auth Redirect: Erro ao buscar perfil:", profileError);

                        // MODIFICAÇÃO AQUI: Verificação mais rigorosa
                        // Se não existe perfil ou se o perfil existe mas não tem CPF/CNPJ ou telefone, 
                        // redireciona para completar perfil
                        if (profileError || !profileData || !profileData.cpf_cnpj || !profileData.phone) {
                            //console.log("Auth Redirect: Perfil incompleto ou inexistente, redirecionando para complete-profile");
                            setMessage('Redirecionando para completar seu perfil...');
                            setTimeout(() => navigate('/complete-profile'), 1000);
                            return;
                        }

                        // Se chegamos aqui, o perfil existe e está completo
                        //console.log("Auth Redirect: Perfil completo, redirecionando para dashboard");
                        setMessage('Login bem-sucedido! Redirecionando para o Dashboard...');
                        setTimeout(() => navigate('/dashboard'), 1000);
                    } catch (profileQueryError) {
                        console.error("Auth Redirect: Erro ao consultar perfil:", profileQueryError);
                        // Se houver erro ao consultar o perfil, vamos para complete-profile para garantir
                        //console.log("Auth Redirect: Erro ao buscar perfil, redirecionando para complete-profile");
                        setMessage('Redirecionando para completar seu perfil...');
                        setTimeout(() => navigate('/complete-profile'), 1000);
                        return;
                    }
                } else {
                    // Não conseguimos obter dados do usuário, melhor redirecionar para login
                    //console.log("Auth Redirect: Sem dados de usuário válidos, redirecionando para login");
                    setMessage('Informações do usuário não encontradas. Redirecionando para login...');
                    setTimeout(() => navigate('/login'), 2000);
                }

            } catch (error) {
                console.error('Erro no redirecionamento de autenticação:', error);
                setError(true);
                setMessage('Ocorreu um erro durante a autenticação. Tente novamente.');
                setTimeout(() => navigate('/login'), 3000);
            }
        };

        handleAuthRedirect();
    }, [navigate, location]);

    return (
        <Center h="100vh" bg="gray.50">
            <VStack spacing={6}>
                <Spinner
                    size="xl"
                    thickness="4px"
                    speed="0.65s"
                    color={error ? "red.500" : "brand.primary"}
                />
                <Text
                    fontSize="lg"
                    fontWeight="medium"
                    textAlign="center"
                    color={error ? "red.500" : "gray.700"}
                    maxW="400px"
                >
                    {message}
                </Text>

                {/* Botão para ajudar no debug durante o desenvolvimento */}
                {process.env.NODE_ENV === 'development' && (
                    <Button
                        mt={4}
                        colorScheme="blue"
                        onClick={() => navigate('/complete-profile')}
                    >
                        Ir para Completar Perfil
                    </Button>
                )}
            </VStack>
        </Center>
    );
};

export default AuthRedirect;